import Axios from '@/axios';

// 预警查询
export const getAlarm = params => {  
  return Axios({
    url: '/face/web/alarm/index_alarm',
    method: 'GET',
    type: 'json',
    params
  })
}